import { Injectable } from '@angular/core';
import * as swedish from "./languages/language.se";
import * as english from "./languages/language.en";
import * as danish from "./languages/language.dk";
import * as norwegian from "./languages/language.no";
import * as finnish from "./languages/language.fi";
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
//import { AppConfiguration } from 'src/app/app.configuration';
@Injectable({
    providedIn: "root"
})
export class LanguageService {
    private readonly storageKey = 'PUBQ_DASHBOARD_LANGUAGECODE';
    // availableLanguages = [
    //     { lang: "Svenska", code: "se" },
    //     { lang: "English", code: "en" },
    //     { lang: "Dansk", code: "dk" },
    //     { lang: "Norsk", code: "no" }];

    availableLanguages = [
        { lang: "Svenska", code: "se" },
        { lang: "English", code: "en" },
        { lang: "Suomi", code: "fi" }];

    constructor() {
        this.currentLanguage = this.getStoredLanguage();
        moment.locale(this.getMomentLocale(this.currentLanguage));
    }
    currentLanguage = "se";
    currentLanguageSubject = new BehaviorSubject(this.currentLanguage);
    getAvailableLanguages() {
        return this.availableLanguages;
    }
    setLanguage(languageCode: string) {
        this.currentLanguage = languageCode;
        window.localStorage.setItem(this.storageKey, languageCode);
        moment.locale(this.getMomentLocale(languageCode));
        this.currentLanguageSubject.next(this.currentLanguage);
    }
    private getStoredLanguage(): string {
        const storedLanguage = window.localStorage.getItem(this.storageKey);
        const allowedLanguages = this.availableLanguages.map((language) => language.code);
        return storedLanguage && allowedLanguages.includes(storedLanguage)
            ? storedLanguage
            : "se";
    }
    private getMomentLocale(languageCode: string): string {
        switch (languageCode) {
            case "se":
                return "sv";
            case "dk":
                return "da";
            case "no":
                return "nb";
            default:
                return languageCode || "en";
        }
    }
    getString(translationProperty: string, languageCode?: string, parameters?: string[]) {
        if (!languageCode)
            languageCode = this.currentLanguage;
        switch (languageCode) {
            case "se": {
                if (parameters) return swedish.lang.get(translationProperty, parameters);
                else return swedish.lang[translationProperty]
            }
            case "en": {
                if (parameters) return english.lang.get(translationProperty, parameters);
                return english.lang[translationProperty];
            }
            case "dk": {
                if (parameters) return danish.lang.get(translationProperty, parameters);
                return danish.lang[translationProperty];
            }
            case "no": {
                if (parameters) return norwegian.lang.get(translationProperty, parameters);
                return norwegian.lang[translationProperty];
            }
            case "fi": {
                if (parameters) return finnish.lang.get(translationProperty, parameters);
                return finnish.lang[translationProperty];
            }
            default: {
                return null;
            }
        }
    }
}
